module.exports = "<div>\n  <p [ngStyle]=\"getMyStyle()\" class=\"{{ status }}\"></p>\n</div>\n"